import { request } from 'api';
import {
  Contracts,
  DocumentDto,
  ExecutorOrganizationProfileDto,
  getExecutorOrganizationsBody,
} from './types';

export const EdmsService = {
  getContracts(secondPartyOrganizationId: string, skipCount: number, maxResultCount: number) {
    return request<Contracts>(
      'get',
      `/api/Edms/Documents?SecondPartyOrganizationId=${secondPartyOrganizationId}&SkipCount=${skipCount}&MaxResultCount=${maxResultCount}`
    );
  },
  getContractById(id: string) {
    return request<DocumentDto>('get', `/api/Edms/Documents/${id}`);
  },
  contractSignature(body: { id: string; concurrencyStamp: string }) {
    return request<DocumentDto>('put', `/api/Edms/Documents/Signature`, {
      data: body,
    });
  },

  getExecutorOrganizations({
    nameTemplate,
    tinTemplate,
    ftsStatuses,
    skipCount,
    maxResultCount,
  }: getExecutorOrganizationsBody) {
    // Создаем массив для хранения параметров
    const params: string[] = [];

    // Добавляем параметры только если они переданы и не пустые
    if (nameTemplate) params.push(`NameTemplate=${encodeURIComponent(nameTemplate)}`);
    if (tinTemplate) params.push(`TinTemplate=${encodeURIComponent(tinTemplate)}`);

    // Обрабатываем массив ftsStatuses
    if (ftsStatuses && Array.isArray(ftsStatuses) && ftsStatuses.length > 0) {
      ftsStatuses.forEach((status) => {
        params.push(`FtsStatuses=${encodeURIComponent(status)}`);
      });
    }

    if (skipCount !== undefined) params.push(`SkipCount=${encodeURIComponent(skipCount)}`);
    if (maxResultCount !== undefined)
      params.push(`MaxResultCount=${encodeURIComponent(maxResultCount)}`);

    // Создаем строку query параметров
    const queryString = params.join('&');

    return request<Contracts>(
      'get',
      `/api/Edms/ExecutorOrganizations${queryString ? `?${queryString}` : ''}`
    );
  },

  getExecutorOrganizationsById(id: string) {
    return request<ExecutorOrganizationProfileDto>('get', `/api/Edms/ExecutorOrganizations/${id}`);
  },
};
